/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../../services/contract/contract_interfaces.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ContractDetailsFormDirectiveController {
        public static $inject: string[] = [
            '$scope',
            '$state',
            '$filter',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'SettingsLoanerAgreementUploadService',
            'DealerwareVehicleModel',
            'MicroFrontendOrigin',
            'PdfHelperService',
            '$dealerwareInternationalizationData'
        ];

        public contract: any = {
            contractDetails: {
                data: {
                    customer: {}
                }
            }
        };
        public cachedPickupLocation: any;
        public labels: {};

        constructor(public $scope: any,
                    public $state: any,
                    public $filter: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public SettingsLoanerAgreementUploadService: any,
                    public DealerwareVehicleModel: any,
                    public MicroFrontendOrigin: any,
                    public PdfHelperService: any,
                    public $dealerwareInternationalizationData: any) {
                        let _self = this;
                        this.getLabels('contracts');
                        this.$scope.$watch( () => { return _self.contract }, () => { _self.getNotices() });
                    }

        public getLabels(module: string) : void {
            var _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public getNotices(): void {
            let contract = this.contract;
            if (contract && contract.contractDetails && contract.contractDetails.data.current_state === 'started') {
                let car = contract.contractDetails.data.car;
                let startDate = contract.contractDetails.data.actual_pickup;
                if (!this.$scope.collisions) {
                    this.DealerwareVehicleModel.collisions({
                        promise: true,
                        params: {
                            id: car.id,
                            start_date: startDate
                        }
                    }).then(
                        (response) => {
                            this.$scope.collisions = response.data;
                        }
                    );
                }
                if (!this.$scope.warnings) {
                    this.DealerwareVehicleModel.serviceWarnings({
                        promise: true,
                        params: {
                            id: car.id,
                            start_date: startDate
                        }
                    }).then(
                        (response) => {
                            this.$scope.warnings = response.data;
                        }
                    );
                }
            }
        }

        private customDate(paramDate): string {
            return this.$filter('filterInternationalizationDate')(paramDate);
        }

        public get currentContractState() : string {
            if (this.contract && this.contract.contractDetails && this.labels) {
                return this.labels.report.status[this.contract.contractDetails.data.current_state];
            }
            return '';
        }

        public get customCreateDate() : string {
            if (this.contract && this.contract.contractDetails) {
                return this.customDate(this.contract.contractDetails.data.created_at_display);
            }
            return '';
        }

        public get customSchedulePickupDate() : string {
            if (this.contract && this.contract.contractDetails) {
                return this.customDate(this.contract.contractDetails.data.pickup_display);
            }
            return '';
        }

        public get customActualPickupDate() : string {
            if (this.contract && this.contract.contractDetails) {
                return this.customDate(this.contract.contractDetails.data.actual_pickup_display);
            }
            return '';
        }

        public get customScheduledDropoffDate() : string {
            if (this.contract && this.contract.contractDetails) {
                return this.customDate(this.contract.contractDetails.data.dropoff_display);
            }
            return '';
        }

        public get customActualDropoffDate() : string {
            if (this.contract && this.contract.contractDetails) {
                return this.customDate(this.contract.contractDetails.data.actual_dropoff_display);
            }
            return '';
        }

        public get customLastUpdatedDate() : string {
            if (this.contract && this.contract.contractDetails) {
                return this.customDate(this.contract.contractDetails.data.updated_at_display);
            }
            return '';
        }

        public get customerEmail() : string {
            if (this.contract && this.contract.contractDetails && this.contract.contractDetails.data.customer) {
                return this.$filter('filterAnonymizedEmail')(this.contract.contractDetails.data.customer.email);
            }
            return '';
        }

        public get showWarrantyButton() : boolean {
            if (this.contract && this.contract.contractDetails) {
                var current_state = this.contract.contractDetails.data.current_state;
                return current_state === 'started' || current_state === 'finished';
            }
            return false;
        }

        public get warrantyButtonLabel() : string {
            if (this.contract && this.contract.warranty) {
                return Object.keys(this.contract.warranty.master).length ? 'View Warranty' : 'Create Warranty';
            }
            return '';
        }

        public isSaveDisabled() : boolean {
            return this.$scope.contractDetailsForm.service_advisor_id.$pristine &&
                   this.$scope.contractDetailsForm.repair_order.$pristine &&
                   this.$scope.contractDetailsForm.service_vehicle_id.$pristine;
        }

        public saveContract() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.contract.contractDetails.$update({
                promise: true,
                params: { location_id: this.contract.locationId }
            }).then(
                function(response: any) {
                    _self.$scope.contractDetailsForm.$setPristine();
                    loader.close();
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            )
        }

        public cancelContract() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Cancelling...');
            this.contract.cancel().then(
                function(response: any) {
                    _self.contract.loadContractDetails().then(
                        function(response: any) { loader.close(); },
                        function(response: any) { loader.close(); }
                    );
                },
                function(response: any) {
                    loader.close();
                    _self.$dealerwareNotification.apiError(response);
                }
            );
        }

        public startContract() : void {
            const { contractId, locationId } = this.contract;
            const startContractHash = `/${locationId}/contracts/details/${contractId}`;

            window.parent.postMessage({
                type: 'routing',
                hash: startContractHash
            }, this.MicroFrontendOrigin);
        }

        public viewLoanerAgreement() : void {

            var loader = this.$dealerwareLoading.show('Loading...');

            this.contract.DealerwareContractModel.getLoanerAgreementPdf(this.contract)
                .then( (response: any) => {
                    this.PdfHelperService.streamPdfToNewWindow(response.data);
                })
                .catch( (response: any) => {
                    this.$dealerwareNotification.apiError(
                        response.message ? response : 'Driver Agreement couldn\'t be opened'
                    );
                })
                .finally( ( ) => {
                    loader.close();
                });
        }
    }



    getDealerwareWebComponentsModule().controller('ContractDetailsFormDirectiveController', ContractDetailsFormDirectiveController);

    export class ContractDetailsDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ContractDetailsFormDirectiveController';
        public controllerAs     : string    =   'contractDetailsController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {contract: '='};
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/contract/details/contract_details_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
        }

    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareContractDetails",() => new ContractDetailsDirective());
}
